export default __webpack_public_path__ + "locales/ko-KR/EmptyTrashDialog.json?hash=4efab690fd176aec7d74d4452aa63e23";